import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser, clearPatchUser } from 'redux/settings/actions';
import { fetchMe } from 'redux/users/actions';

import { Loader, Dimmer, Checkbox } from 'semantic-ui-react';

import CommonUserIcon from 'components/dashboard/common/CommonUserIcon';
import UserTitle from 'components/dashboard/appearance-content/UserTitle';
import FixedNotification from 'components/common/FixedNotification';
import CommonPopup from 'components/common/CommonPopup';

import CommonImageDropzone from 'components/common/CommonImageDropzone';
import ProFeaturePlaceholder
  from 'components/common/ProFeaturePlaceholder';

import './AvatarSelector.css';


class AvatarSelector extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    patchUser: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    me: PropTypes.object,
    patchUserSuccess: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    patchUserSuccess: null,
  };

  state = {
    showNotification: false,
    showLoader: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.me.avatar !== this.props.me.avatar) {
      setTimeout(() => {
        this.setState({ showLoader: false });
      }, 500);
    }
  }

  onImageDrop = droppedImage => {
    if (droppedImage) {
      const form = new FormData();
      form.append('avatar', droppedImage.imageBlob, droppedImage.name);
      this.props.patchUser(form);
    }
    this.setState({ showLoader: true });
  };

  onImageRemove = () => {
    const form = new FormData();
    form.append('avatar', '');
    this.props.patchUser(form);
    this.setState({ showNotification: true });
  };

  onCheckboxChange = data => {
    const form = new FormData();
    form.append(data.name, data.checked);
    this.props.patchUser(form);
  };

  render() {
    const { me } = this.props;
    const { showNotification, showLoader } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="avatar-selector__component">
            {/* Avatar selector */}
            <div className="avatar-selector-wrapper">
              {/* Avatar Wrapper */}
              <div className="avatar-wrapper">
                <div className="avatar-content">
                  {!showLoader ?
                    <CommonImageDropzone
                      onDropImage={this.onImageDrop}
                    >
                      <CommonUserIcon />
                    </CommonImageDropzone>
                    :
                    <Dimmer active>
                      <Loader />
                    </Dimmer>
                  }
                </div>

                {/* Buttons Wrapper */}
                <div className="buttons-wrapper">
                  <CommonImageDropzone
                    onDropImage={this.onImageDrop}
                  >
                    <div className="button upload">{t("Upload Avatar")}</div>
                  </CommonImageDropzone>

                  {me &&
                    me.avatar &&
                    !me.avatar.includes('static/images/defaults') &&
                    <div
                      className="button remove"
                      onClick={this.onImageRemove}
                      role="button"
                      tabIndex={-1}
                    >
                      <div className="icon" />
                      <div className="text">{t("Remove")}</div>
                    </div>
                  }
                </div>
              </div>

              {/* Title Wrapper */}
              <div className="title-wrapper">
                <div className="user-title">
                  <UserTitle />
                </div>
                <div className="subtext">
                  {t("Profile Title")}
                  <CommonPopup
                    infoIcon
                    type="info"
                  >
                    {t("Title will be shown under avatar")}
                  </CommonPopup>
                </div>
              </div>

            </div>

            <div className="avatar-selector-controls">
              <div className="avatar-selector-controls-wrapper">

                <div className="control-item avatar">
                  <p>{t("Hide Avatar")}</p>
                  <ProFeaturePlaceholder
                    noKeyIcon
                    proLabel
                    locked={
                      me &&
                      me.subscription &&
                      !me.subscription.ff_username_avatar_hide
                    }
                    placeholderContent={
                      <div>
                        {t("You can hide avatar on the PRO plan.")}
                      </div>
                    }
                    className="avatar-selector-controls-pro-placeholder"
                  >
                    <div className="switcher-wrapper">
                      <span>{t("OFF")}</span>
                      <Checkbox
                        toggle
                        checked={me.avatar_is_hidden || false}
                        name="avatar_is_hidden"
                        onChange={(_e, data) => { this.onCheckboxChange(data); }}
                        disabled={me &&
                          me.subscription &&
                          !me.subscription.ff_username_avatar_hide
                        }
                      />
                      <span>{t("ON")}</span>
                    </div>
                  </ProFeaturePlaceholder>
                </div>

                <div className="control-item profile-title">
                  <p>{t("Hide Title")}</p>
                  <ProFeaturePlaceholder
                    proLabel
                    locked={
                      me &&
                      me.subscription &&
                      !me.subscription.ff_username_avatar_hide
                    }
                    placeholderContent={
                      <div>
                        {t("You can hide title on the PRO plan.")}
                      </div>
                    }
                    className="avatar-selector-controls-pro-placeholder"
                  >
                    <div className="switcher-wrapper">
                      <span>{t("OFF")}</span>
                      <Checkbox
                        toggle
                        checked={me.username_is_hidden || false}
                        name="username_is_hidden"
                        onChange={(_e, data) => { this.onCheckboxChange(data); }}
                        disabled={me &&
                          me.subscription &&
                          !me.subscription.ff_username_avatar_hide
                        }
                      />
                      <span>{t("ON")}</span>
                    </div>
                  </ProFeaturePlaceholder>
                </div>
              </div>
            </div>

            {showNotification &&
              <FixedNotification
                onFadeComplete={() => {
                  this.setState({ showNotification: false });
                }}
              >
                {t("Avatar has been removed!")}
              </FixedNotification>
            }
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
    clearPatchUser,
    fetchMe,
  },
)(AvatarSelector);
